export const bot = {
    state: {
        botId: '',
        botTitle: ''
    },
    mutations: {
        'SET_BOT_ID' (state , botId){
            state.botId = botId
        },
        'SET_BOT_TITLE' (state, botTitle){
            state.botTitle = botTitle
        }
    },
    actions: {
        setBotId({commit},botId){
            commit('SET_BOT_ID',botId)
        },
        setBotTitle({commit},botTitle){
            commit('SET_BOT_TITLE',botTitle)
        }
    }
}
